import { createAction, handleActions } from "redux-actions";

export const BEGIN_STATIC_PAGE_LAYOUT =
  "app/staticPageLayout/BEGIN_STATIC_PAGE_LAYOUT";
export const SET_STATIC_PAGE_LAYOUT =
  "app/staticPageLayout/SET_STATIC_PAGE_LAYOUT";
export const RESET_STATIC_PAGE_LAYOUT =
  "app/staticPageLayout/RESET_STATIC_PAGE_LAYOUT";

export const beginStaticPageLayout = createAction(BEGIN_STATIC_PAGE_LAYOUT);

export const setStaticPageLayout = createAction(
  SET_STATIC_PAGE_LAYOUT,
  ({ fullWidth, hideMenuAndSearch }) => ({
    fullWidth: !!fullWidth,
    hideMenuAndSearch: !!hideMenuAndSearch
  })
);

export const resetStaticPageLayout = createAction(RESET_STATIC_PAGE_LAYOUT);

export const initialState = {
  isStaticPageRoute: false,
  layoutResolved: true,
  fullWidth: false,
  hideMenuAndSearch: false
};

export default handleActions(
  {
    [BEGIN_STATIC_PAGE_LAYOUT]: state => ({
      isStaticPageRoute: true,
      layoutResolved: false,
      fullWidth: state.isStaticPageRoute ? state.fullWidth : false,
      hideMenuAndSearch: true
    }),
    [SET_STATIC_PAGE_LAYOUT]: (state, { payload }) => ({
      ...state,
      isStaticPageRoute: true,
      layoutResolved: true,
      fullWidth: payload.fullWidth,
      hideMenuAndSearch: payload.hideMenuAndSearch
    }),
    [RESET_STATIC_PAGE_LAYOUT]: () => ({ ...initialState })
  },
  initialState
);
